// Given any pasted input (full iframe snippet, bare URL, or partial), return the src URL.
// Examples:
//   '<iframe src="https://www.bandlab.com/embed/collection/?id=xxx" ...></iframe>' -> extracted
//   'https://www.bandlab.com/embed/?id=xxx'                                       -> unchanged
//   ''                                                                            -> ''
export function extractEmbedSrc(input) {
  if (!input) return "";
  const s = String(input).trim();
  if (!s) return "";
  // Try to pull src="..." from anywhere in the string
  const m = s.match(/src\s*=\s*["']([^"']+)["']/i);
  if (m && m[1]) return m[1];
  return s;
}
